<template>
  <div class="content">
    <card class="text-left">
      <template slot="header">
        <h4 class="card-title">유저 투표 현황</h4>
        <p class="card-category">선택한 투표(poll)의 참여자 cast 현황을 조회합니다. (읽기 전용)</p>
      </template>
      <div class="row">
        <div class="col-md-4">
          <label class="col-form-label">유저 ID 필터</label>
          <el-input v-model="userId" placeholder="유저 ID" clearable />
        </div>
        <div class="col-md-2">
          <label class="col-form-label">&nbsp;</label>
          <base-button @click="search" type="default" block>검색</base-button>
        </div>
      </div>
    </card>

    <card class="text-left">
      <template slot="header">
        <h4 class="card-title">유저별 기여도 집계</h4>
      </template>
      <div class="row">
        <el-table :data="summary" style="width: 100%">
          <el-table-column prop="userName" label="유저명" :min-width="160">
            <template slot-scope="props">{{ props.row.userName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="castCount" label="cast수" :min-width="80" align="right">
            <template slot-scope="props">{{ Number(props.row.castCount || 0).toLocaleString() }}</template>
          </el-table-column>
          <el-table-column prop="royalAmount" label="로열" :min-width="100" align="right">
            <template slot-scope="props">{{ Number(props.row.royalAmount || 0).toLocaleString() }}</template>
          </el-table-column>
          <el-table-column prop="blipAmount" label="블립" :min-width="100" align="right">
            <template slot-scope="props">{{ Number(props.row.blipAmount || 0).toLocaleString() }}</template>
          </el-table-column>
          <el-table-column prop="totalVoteTimes" label="총표수" :min-width="100" align="right">
            <template slot-scope="props">{{ Number(props.row.totalVoteTimes || 0).toLocaleString() }}</template>
          </el-table-column>
        </el-table>
      </div>
    </card>

    <card class="text-left">
      <template slot="header">
        <h4 class="card-title">cast 목록</h4>
      </template>
      <div class="row">
        <el-table :data="data" style="width: 100%">
          <el-table-column prop="userName" label="유저명" :min-width="160">
            <template slot-scope="props">{{ props.row.userName || "-" }}</template>
          </el-table-column>
          <el-table-column label="선택지명" :min-width="220">
            <template slot-scope="props">{{ formatOptions(props.row.optionNames) }}</template>
          </el-table-column>
          <el-table-column prop="royalAmount" label="로열" :min-width="90" align="right">
            <template slot-scope="props">{{ Number(props.row.royalAmount || 0).toLocaleString() }}</template>
          </el-table-column>
          <el-table-column prop="blipAmount" label="블립" :min-width="90" align="right">
            <template slot-scope="props">{{ Number(props.row.blipAmount || 0).toLocaleString() }}</template>
          </el-table-column>
          <el-table-column prop="totalVoteTimes" label="총표수" :min-width="90" align="right">
            <template slot-scope="props">{{ Number(props.row.totalVoteTimes || 0).toLocaleString() }}</template>
          </el-table-column>
          <el-table-column label="요청일시" :min-width="170">
            <template slot-scope="props">{{ formatDateTime(props.row.regTime) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="row">
        <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
      </div>
    </card>
  </div>
</template>
<script>
import { Table, TableColumn, Input } from "element-ui";
import { Card, BaseButton, BasePagination } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    Card,
    BaseButton,
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
  },
  async created() {
    if (!this.$route.query.pollId) {
      window.Toast.error("잘못된 접근입니다");
      history.go(-1);
      return;
    }
    this.pollId = this.$route.query.pollId;
    await Promise.all([this.getCasts(), this.getSummary()]);
  },
  data() {
    return {
      pollId: null,
      data: [],
      summary: [],
      userId: "",
      currentPage: 1,
      totalPages: null,
      limit: 20,
    };
  },
  watch: {
    currentPage() {
      this.getCasts(this.currentPage);
    },
  },
  methods: {
    formatDateTime,
    formatOptions(names) {
      if (!Array.isArray(names) || names.length === 0) return "-";
      return names.map((n) => n || "-").join(", ");
    },
    search() {
      this.currentPage = 1;
      this.getCasts(1);
    },
    async getCasts(page) {
      const params = { page: page ? page : 1, limit: this.limit };
      if (this.userId) params.userId = this.userId;
      return this.$axios.get(`/votes/${this.pollId}/casts`, { params }).then((res) => {
        const payload = res.data.data;
        this.data = payload.data;
        const total = payload.meta ? payload.meta.total : 0;
        this.totalPages = Math.max(1, Math.ceil(total / this.limit));
      });
    },
    async getSummary() {
      return this.$axios.get(`/votes/${this.pollId}/casts/summary`).then((res) => {
        this.summary = res.data.data.data;
      });
    },
  },
};
</script>
<style scoped></style>
